import { SUCCESS, FETCH_SPONSOR_LIST } from '../constants/actionApi';
import { addOrUpdateItemsInState } from '../helpers/data';
import initialState from '../store/initialState';
import { SC_SPONSOR_LIST, UPDATED } from '../constants/socket';

export default (state = initialState.sponsorLists, { type, payload }) => {
  switch (type) {
    case FETCH_SPONSOR_LIST + SUCCESS:
    case SC_SPONSOR_LIST + UPDATED:
      return addOrUpdateItemsInState(state, payload.data);
    default:
      return state;
  }
};
